// extracted by mini-css-extract-plugin
module.exports = {"list":"a10a3f92e9--list--1UZ1B","item":"a10a3f92e9--item--25mCm","more":"a10a3f92e9--more--2wGNc","close":"a10a3f92e9--close--2Tvdo"};